import { spinner } from 'vue-strap'

export default {
    extends: spinner,
    props: { text: { type: String, default: 'Loading, please wait' } },
    mounted () {
        this.$el.setAttribute('role', 'status')
        this.$el.setAttribute('aria-live', 'polite')
    }
}



// WEBPACK FOOTER //
// ./src/accessibility/Spinner.js